var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',[_c('h1',[_vm._v("PortaSigma")]),_c('img',{staticClass:"mx-auto mb-2",attrs:{"src":"img/PortaSigma-logo.svg","alt":"PortaSigma","onerror":"this.src='img/PortaSigma-logo.png'"}})])
}]

export { render, staticRenderFns }